// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"f088fe2f","120":"47c9fa06"}[chunkId] + ".chunk.css";
};